import React, { useRef } from 'react';
import { Link, Redirect, Rout, useHistory } from 'react-router-dom';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  InteractionItem
} from 'chart.js';
import { Bar, getElementAtEvent } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
)

const DayLineChart = ({monthText, labels, title}) => {

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: true,
        text: title + " - " + monthText
      },
    },
  };

  const data = {
    labels,
    datasets: [
      {
        label: 'Dataset 1',
        data: labels.map(() => Math.random() * 100),
        borderColor: 'rgb(80, 69, 255)',
        borderWidth: 2,
        backgroundColor: 'rgba(80, 69, 255, 0.5)',
      },
      {
        label: 'Dataset 2',
        data: labels.map(() => Math.random() * 100),
        borderColor: 'rgb(255, 69, 69)',
        borderWidth: 2,
        backgroundColor: 'rgba(255, 69, 69, 0.5)',
      },
      {
        label: 'Dataset 3',
        data: labels.map(() => Math.random() * 100),
        borderColor: 'rgb(20, 151, 106)',
        borderWidth: 2,
        backgroundColor: 'rgba(20, 151, 106, 0.5)',
      },
      {
        label: 'Tendencia',
        data: labels.map(() => 50),
        borderColor: 'rgb(214, 214, 214)',
        backgroundColor: 'rgba(214, 214, 214, 0.5)',
      }
    ]
  }

  return (
    <Line options={options} data={data}></Line>
  )
}

export default DayLineChart